import React from "react";
import { Link } from "react-router-dom";
import { Card, CardContent, CardHeader } from "ui/components/card";
import { Separator } from "ui/components/separator";
import { DisplayHours } from "components/display/hours";
import { assetUrl } from "utils";

const PCCardRenderer = ({ items }) => {
  return (
    <div className="flex flex-wrap gap-4 m-6">
      {items.map((item) => (
        <Link key={item.project_id} to={item.project_id}>
          <Card className="w-96 shadow-none">
            <CardHeader className="font-semibold">
              {/* <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center">
                <img
                  src={assetUrl(item.project_logo)}
                  className="w-10 h-10 object-contain rounded-md"
                />
              </div> */}
              {item.project_name}
            </CardHeader>
            <Separator />
            <CardContent className="text-sm">
              <div className="grid grid-cols-2">
                <span className="text-muted-foreground">Logged Hours</span>
                <span className="text-card-foreground text-right ">
                  <DisplayHours
                    value={item.logged || 0}
                    precision={0}
                    format={true}
                  />
                </span>
              </div>
              <div className="grid grid-cols-2">
                <span className="text-muted-foreground text-sm ">
                  Approved Hours
                </span>
                <span className="text-card-foreground text-right ">
                  <DisplayHours
                    value={item.approved || 0}
                    precision={0}
                    format={true}
                  />
                </span>
              </div>
              <div className="grid grid-cols-2">
                <span className="text-muted-foreground text-sm ">
                  Unapproved Hours
                </span>
                <span className="text-card-foreground text-right ">
                  <DisplayHours
                    value={item.unapproved || 0}
                    precision={0}
                    format={true}
                  />
                </span>
              </div>
              <div className="grid grid-cols-2">
                <span className="text-muted-foreground text-sm ">
                  Unreviewed Hours
                </span>
                <span className="text-card-foreground text-right font-bold">
                  <DisplayHours
                    value={item.unreviewed || 0}
                    precision={0}
                    format={true}
                  />
                </span>
              </div>
            </CardContent>
          </Card>
        </Link>
      ))}
    </div>
  );
};

export default PCCardRenderer;
